import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["direction", "className"];
import React from 'react';
import useStyleOverride from "../../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
import ChevronLeft from "./chevron-left-icon.svg.js";
import ChevronRight from "./chevron-right-icon.svg.js";
import clsx from 'clsx';
export var OverlayToggleButton = _ref => {
  var {
      direction,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyleOverride('layouts/TwoColumnOverlayMap/OverlayToggleButton', baseStyles);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(styles.OverlayToggleButton, className)
  }, rest), direction === 'left' ? /*#__PURE__*/React.createElement(ChevronLeft, null) : /*#__PURE__*/React.createElement(ChevronRight, null));
};
export default OverlayToggleButton;
//# sourceMappingURL=index.js.map